export function initModalOptions(config) {
  const csrfToken = config.csrfToken,
    isAdmin = config.isAdmin;
  let currentRatingIdForModal = null;
  let currentCommentIdForModal = null;

  // Document-level event listener for rating 3-dot button
  document.addEventListener('click', (e) => {
    const ratingOptionsBtn = e.target.closest('.rating-options-btn');
    if (ratingOptionsBtn) {
      e.preventDefault();
      // Only allow logged-in users to see rating options.
      if (!config.isAuthenticated) {
        $('#authModal').modal('show');
        return;
      }
      const ratingId = ratingOptionsBtn.getAttribute('data-rating-id');
      const isOwner = ratingOptionsBtn.getAttribute('data-is-owner');
      openRatingOptionsSheet(ratingId, isOwner);
    }
  });

  // Document-level event listener for comment 3-dot button
  document.addEventListener('click', (e) => {
    const commentOptionsBtn = e.target.closest('.comment-options-btn');
    if (commentOptionsBtn) {
      e.preventDefault();
      // Only allow logged-in users to see comment options.
      if (!config.isAuthenticated) {
        $('#authModal').modal('show');
        return;
      }
      const commentItem = commentOptionsBtn.closest('.comment-item');
      if (!commentItem) return;
      const commentId = commentItem.getAttribute('data-comment-id');
      const isOwner = commentItem.dataset.isOwner;
      openCommentOptionsMenu(commentId, isOwner);
    }
  });

  // -------------------------------------------------------------
  // openRatingOptionsSheet: Show delete if owner/admin; otherwise, report.
  // -------------------------------------------------------------
  function openRatingOptionsSheet(ratingId, isOwner) {
    currentRatingIdForModal = ratingId;
    const isOwnerOrAdmin = (isOwner === 'true') || isAdmin;
    
    const deleteRatingBtn = document.getElementById('deleteRatingBtn');
    if (deleteRatingBtn) {
      if (isOwnerOrAdmin) {
        deleteRatingBtn.style.setProperty('display', 'block', 'important');
        deleteRatingBtn.dataset.ratingId = ratingId;
      } else {
        deleteRatingBtn.style.setProperty('display', 'none', 'important');
        deleteRatingBtn.removeAttribute('data-ratingId');
      }
    }
    
    const reportRatingBtn = document.getElementById('reportRatingBtn');
    if (reportRatingBtn) {
      if (isOwnerOrAdmin) {
        reportRatingBtn.style.setProperty('display', 'none', 'important');
        reportRatingBtn.removeAttribute('data-ratingId');
      } else {
        reportRatingBtn.style.setProperty('display', 'block', 'important');
        reportRatingBtn.dataset.ratingId = ratingId;
      }
    }
    
    const ratingOptionsModal = document.getElementById('ratingOptionsModal');
    if (ratingOptionsModal) {
      $('#ratingOptionsModal').modal('show');
    }
  }

  // -------------------------------------------------------------
  // openCommentOptionsMenu: Show delete if owner/admin; otherwise, report.
  // -------------------------------------------------------------
  function openCommentOptionsMenu(commentId, isOwner) {
    currentCommentIdForModal = commentId;

    const deleteCommentBtn = document.getElementById('deleteCommentBtn');
    if (deleteCommentBtn) {
      if (isOwner === 'true' || isAdmin) {
        deleteCommentBtn.style.setProperty('display', 'block', 'important');
        deleteCommentBtn.dataset.commentId = commentId;
      } else {
        deleteCommentBtn.style.setProperty('display', 'none', 'important');
        deleteCommentBtn.removeAttribute('data-commentId');
      }
    }

    const reportCommentBtn = document.getElementById('reportCommentBtn');
    if (reportCommentBtn) {
      if (isOwner === 'true' || isAdmin) {
        // For your own comment, hide the report button.
        reportCommentBtn.style.setProperty('display', 'none', 'important');
        reportCommentBtn.removeAttribute('data-commentId');
      } else {
        reportCommentBtn.style.setProperty('display', 'block', 'important');
        reportCommentBtn.dataset.commentId = commentId;
      }
    }
    
    const commentOptionsModal = document.getElementById('commentOptionsModal');
    if (commentOptionsModal) {
      $('#commentOptionsModal').modal('show');
    }
  }

  // -------------------------------------------------------------
  // RATING OPTIONS MODAL Buttons
  // -------------------------------------------------------------
  const deleteRatingBtn = document.getElementById('deleteRatingBtn');
  if (deleteRatingBtn) {
    deleteRatingBtn.addEventListener('click', async () => {
      if (!currentRatingIdForModal) return;
      const confirmed = confirm("Are you sure you want to delete your rating?");
      if (!confirmed) return;
      await deleteRating(currentRatingIdForModal, csrfToken);
      $('#ratingOptionsModal').modal('hide');
    });
  }
  const reportRatingBtn = document.getElementById('reportRatingBtn');
  if (reportRatingBtn) {
    reportRatingBtn.addEventListener('click', async () => {
      if (!currentRatingIdForModal) return;
      const confirmed = confirm("Report this rating as inappropriate?");
      if (!confirmed) return;
      await reportRating(currentRatingIdForModal, csrfToken);
      $('#ratingOptionsModal').modal('hide');
    });
  }

  // -------------------------------------------------------------
  // COMMENT OPTIONS MODAL Buttons
  // -------------------------------------------------------------
  const deleteCommentBtn = document.getElementById('deleteCommentBtn');
  if (deleteCommentBtn) {
    deleteCommentBtn.addEventListener('click', async () => {
      if (!currentCommentIdForModal) return;
      const confirmed = confirm("Are you sure you want to delete this comment?");
      if (!confirmed) return;
      await deleteComment(currentCommentIdForModal, csrfToken);
      $('#commentOptionsModal').modal('hide');
    });
  }
  const reportCommentBtn = document.getElementById('reportCommentBtn');
  if (reportCommentBtn) {
    reportCommentBtn.addEventListener('click', async () => {
      if (!currentCommentIdForModal) return;
      const confirmed = confirm("Report this comment as inappropriate?");
      if (!confirmed) return;
      await reportComment(currentCommentIdForModal, csrfToken);
      $('#commentOptionsModal').modal('hide');
    });
  }
}

// The following functions remain as implemented previously.
async function deleteRating(ratingId, csrfToken) {
  try {
    const resp = await fetch(`/account/delete_rating/${ratingId}`, {
      method: 'POST',
      headers: {
        'X-CSRFToken': csrfToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({}),
    });
    if (!resp.ok) {
      window.showToast('Error deleting rating.', 'danger');
      return;
    }
    const data = await resp.json();
    if (data.success) {
      const ratingElem = document.getElementById(`rating-${ratingId}`);
      if (ratingElem) {
        ratingElem.classList.add('fade-out');
        setTimeout(() => ratingElem.remove(), 300);
      }
      window.showToast('Rating deleted successfully.', 'success');
    } else {
      window.showToast(data.error || 'Could not delete rating.', 'danger');
    }
  } catch (error) {
    console.error('Error deleting rating:', error);
    window.showToast('Error deleting rating.', 'danger');
  }
}

async function reportRating(ratingId, csrfToken) {
  try {
    const formData = new FormData();
    formData.append('reason', 'User reported via 3-dots menu');
    const resp = await fetch(`/flag_rating/${ratingId}`, {
      method: 'POST',
      headers: { 'X-CSRFToken': csrfToken },
      body: formData,
    });
    if (!resp.ok) {
      window.showToast('Error reporting rating.', 'danger');
      return;
    }
    const data = await resp.json();
    if (data.success) {
      window.showToast('Rating reported successfully!', 'success');
    } else {
      window.showToast(data.error || 'Could not report rating.', 'danger');
    }
  } catch (error) {
    console.error('Error reporting rating:', error);
    window.showToast('Error reporting rating.', 'danger');
  }
}

async function deleteComment(commentId, csrfToken) {
  const commentElem = document.getElementById(`comment-${commentId}`);
  if (!commentElem) return;
  const ratingId = commentElem.getAttribute('data-rating-id');
  if (!ratingId) return;
  try {
    const resp = await fetch(`/feed/${ratingId}/comments/${commentId}`, {
      method: 'DELETE',
      headers: { 'X-CSRFToken': csrfToken },
    });
    if (!resp.ok) {
      window.showToast('Error deleting comment.', 'danger');
      return;
    }
    const data = await resp.json();
    if (data.success) {
      commentElem.classList.add('fade-out');
      setTimeout(() => commentElem.remove(), 300);
      const commentCountSpan = document.getElementById(`comment-count-${ratingId}`);
      if (commentCountSpan) {
        const oldVal = parseInt(commentCountSpan.textContent, 10);
        commentCountSpan.textContent = Math.max(oldVal - 1, 0);
      }
      window.showToast('Comment deleted successfully.', 'success');
    } else {
      window.showToast(data.error || 'Could not delete comment.', 'danger');
    }
  } catch (error) {
    console.error('Error deleting comment:', error);
    window.showToast('Error deleting comment.', 'danger');
  }
}

async function reportComment(commentId, csrfToken) {
  try {
    const formData = new FormData();
    formData.append('reason', 'User reported via 3-dots comment menu');
    const resp = await fetch(`/flag_comment/${commentId}`, {
      method: 'POST',
      headers: { 'X-CSRFToken': csrfToken },
      body: formData,
    });
    if (!resp.ok) {
      window.showToast('Error reporting comment.', 'danger');
      return;
    }
    const data = await resp.json();
    if (data.success) {
      window.showToast('Comment reported successfully!', 'success');
    } else {
      window.showToast(data.error || 'Could not report comment.', 'danger');
    }
  } catch (error) {
    console.error('Error reporting comment:', error);
    window.showToast('Error reporting comment.', 'danger');
  }
}
